import axios from "./interceptorKhfw.js";
import Qs from "qs";
export const get = (url, params = {}, contentType, responseType) => {
  // console.log(params);
  return axios.get(url, {
    params,
    headers: {
      "content-type": contentType || "application/json",
    },
    responseType,
  });
};

export const post = (url, params = {}, config = {}) => {
  // console.log(loadingText);
  return axios.post(
    url,
    Qs.stringify(params, { allowDots: true }),
    Object.assign(
      {
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
      },
      config
    )
  );
};

export const _post = (url, params = {}, contentType, others) => {
  return axios.post(url, params, {
    headers: {
      "content-type": contentType || "application/json",
    },
    ...others,
  });
};
